// extracted by mini-css-extract-plugin
export default {"lo":"_2fg1R7Zu62"};